<template>
  <div class="section">
    <div class="section-header">
      <div class="section-info">
        <span class="section-title">资源管理</span>
      </div>
      <div class="section-controls">
        <button class="header-action" title="上传资源" @click="$emit('upload')">
          <ElIcon><Upload /></ElIcon>
        </button>
        <button class="header-action" title="新建JSON" @click="$emit('create-json')">
          <ElIcon><Document /></ElIcon>
        </button>
      </div>
    </div>
    <div class="section-content" v-show="expanded">
      <div class="resource-filter">
        <select :value="filter" @change="$emit('set-filter', ($event.target as HTMLSelectElement).value)" class="filter-select">
          <option value="all">全部类型</option>
          <option value="json">JSON</option>
          <option value="image">图片</option>
          <option value="video">视频</option>
          <option value="other">其它文件</option>
        </select>
      </div>
      <div class="resource-list">
        <div class="resource-item" v-for="resource in resources" :key="resource.id" @click="$emit('preview', resource)">
          <div class="resource-icon">
            <img v-if="resource.type === 'image' && resource.url" :src="resource.url" alt="预览">
            <span v-else class="file-type-icon">{{ getFileTypeIcon(resource.type) }}</span>
          </div>
          <div class="resource-info">
            <div class="resource-name">{{ resource.name }}</div>
            <div class="resource-meta">{{ resource.size }} | {{ resource.type }}</div>
          </div>
          <div class="resource-actions">
            <button class="icon-btn primary" @click.stop="$emit('download', resource)" title="下载">
              <ElIcon><Download /></ElIcon>
            </button>
            <button class="icon-btn danger" @click.stop="$emit('delete', resource)" title="删除">
              <ElIcon><Close /></ElIcon>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ElIcon, Upload, Document, Download, Close } from '@/plugins/elementPlus'

const props = defineProps<{
  expanded: boolean
  filter: string
  resources: any[]
}>()

const emit = defineEmits<{
  (e: 'toggle'): void
  (e: 'set-filter', value: string): void
  (e: 'upload'): void
  (e: 'create-json'): void
  (e: 'preview', resource: any): void
  (e: 'download', resource: any): void
  (e: 'delete', resource: any): void
}>()

function getFileTypeIcon(type: string): string {
  switch (type) {
    case 'json': return '📄'
    case 'image': return '🖼️'
    case 'video': return '🎥'
    default: return '📎'
  }
}
</script>

<style scoped lang="scss">
.section { margin: 0; border-radius: 6px; background: #1f1f1f; overflow: hidden; display: flex; flex-direction: column; }
.section-header { display: flex; align-items: center; justify-content: space-between; padding: 6px 8px; border-bottom: 1px solid #333333; cursor: pointer; user-select: none; }
.section-info { display: flex; align-items: center; gap: 8px; flex: 1; }
.section-title { color: #cccccc; font-size: 12px; font-weight: 500; }
.section-controls { display: flex; align-items: center; gap: 6px; height: 30px; }
.header-action { background: #333333; border: none; width: 20px; height: 20px; color: #bbb; border-radius: 4px; cursor: pointer; display: inline-flex; align-items: center; justify-content: center; }
.header-action:disabled { opacity: 0.5; cursor: not-allowed; }
.header-action:hover { background: #333; color: #fff; border-color: #666; }
.section-content { padding: 6px; flex: 1; overflow-y: auto; background: #1e1e1e; }
.resource-filter { margin-bottom: 6px; }
.filter-select { width: 100%; background: #2a2a2a; color: #ccc; border: 1px solid #444; border-radius: 4px; height: 26px; }
.resource-list { display: flex; flex-direction: column; gap: 4px; }
.resource-item { display: flex; align-items: center; justify-content: space-between; padding: 6px 8px; background: #2a2a2a; border: 1px solid transparent; border-radius: 4px; cursor: pointer; transition: all 0.2s; }
.resource-item:hover { background: #333; border-color: #444; }
.resource-icon img { width: 24px; height: 24px; object-fit: cover; border-radius: 4px; }
.file-type-icon { color: #bbb; font-size: 14px; }
.resource-info { flex: 1; min-width: 0; }
.resource-name { color: #cccccc; font-size: 11px; font-weight: 500; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.resource-meta { color: #888; font-size: 10px; margin-top: 2px; }
.icon-btn { background: none; border: 1px solid #444; color: #bbb; padding: 4px 6px; border-radius: 4px; cursor: pointer; transition: all .2s; }
.icon-btn:hover { background: #333; color: #fff; border-color: #666; }
.icon-btn.danger:hover { background: #3a2424; border-color: #8b0000; color: #ffdddd; }
</style>
